<div class="trigger" #trigger
     [colorPicker]="color"
     [cpAlphaChannel]="'always'"
     (colorPickerChange)="emitSelectedEvent($event)"
     [cpDialogDisplay]="'inline'"
     [cpToggle]="false"
></div>


// WEBPACK FOOTER //
// /mnt/e/apps/architect3/client/node_modules/vebto-client/core/ui/color-picker/colorpicker-panel.component.html